import { render } from "./rejectPaperIcon.vue?vue&type=template&id=1b2e0241"
import script from "./rejectPaperIcon.vue?vue&type=script&lang=js"
export * from "./rejectPaperIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__